// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xkJAz","content":"styles_content__K9BN9"};